
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns7d7a0aec64b98c706f1cb6fffa7d0721en from './en.yaml'
            i18n.addResourceBundle('en', '7d7a0aec64b98c706f1cb6fffa7d0721', flattenObject(ns7d7a0aec64b98c706f1cb6fffa7d0721en), true, true);
        
        export default '7d7a0aec64b98c706f1cb6fffa7d0721';
    